__turbopack_context__.v({
  "largePromptButton": "Cb0qwG_largePromptButton",
  "noUhxButton": "Cb0qwG_noUhxButton",
  "sectionContainer": "Cb0qwG_sectionContainer",
  "sectionTitleRow": "Cb0qwG_sectionTitleRow",
  "uhxCard": "Cb0qwG_uhxCard",
  "uhxContentContainer": "Cb0qwG_uhxContentContainer",
});
